

















import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { BotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import findPropertyById from '../../../../../../../logic/Helpers/findPropertyById'
import PropertyCondition, {
  PropertyConditionAction
} from '../../../logic/ConditionTypes/PropertyCondition'
import BaseValue from '../../../logic/PropertyConditionValues/BaseValue'
import CalculateValue from '../../../logic/PropertyConditionValues/CalculateValue'
import ConstantValue from '../../../logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../logic/PropertyConditionValues/PropertyValue'

@Component
export default class PropertyConditionView extends Vue {
  @Prop() condition!: PropertyCondition

  @Prop() i18n!: i18n

  @Prop() properties!: Array<BotProperty>

  icons = {
    [PropertyConditionAction.Less]: () => import('./icons/less.vue'),
    [PropertyConditionAction.More]: () => import('./icons/more.vue'),
    [PropertyConditionAction.Contains]: () => import('./icons/more.vue'),
    [PropertyConditionAction.EndsWith]: () => import('./icons/endWith.vue'),
    [PropertyConditionAction.Equals]: () => import('./icons/equals.vue'),
    [PropertyConditionAction.StartsWith]: () => import('./icons/startWith.vue'),
    [PropertyConditionAction.LessOrEquals]: () => import('./icons/lessOrEquals.vue'),
    [PropertyConditionAction.MoreOrEquals]: () => import('./icons/moreOrEquals.vue'),
  }

  getPropertyValue(value: BaseValue): string | number | null {
    if (value instanceof PropertyValue) {
      const property = findPropertyById(this.properties, value.property_index)

      if (property) {
        return property.name ?? property.type
      } else {
        return this.i18n.t('property_is_undefined').toString()
      }
    }

    if (value instanceof ConstantValue || value instanceof CalculateValue) {
      return value.value
    }

    return null
  }
}
